<template>
    <div class="tab-pane fade in active show" id="members" style="overflow-x: auto;">
        <loader-gif v-if="isRequestSubscription" />
        <element-per-page />
        <img ref="refLogo" src="@/assets/img/logo-black.png" alt="store" style="display: none;">
        <table v-if="subscriptionMembers && subscriptionMembers?.length > 0"
            class="datatables table table-striped table-bordered  ">
            <thead class="thead-dark">
                <tr>
                    <th v-if="!isMember">
                        {{ i18n.t('tables.members.matricule') }}
                    </th>
                    <th v-if="!isMember">
                        {{ i18n.t('tables.members.name') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.members.contractNumber') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.subscription_member.title') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.subscription_member.created_at') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.subscription_member.start_date') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.subscription_member.end_date') }}
                    </th>

                    <th>
                        {{ i18n.t('tables.subscription_member.total_amount') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.subscription_member.total_amount_paid') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.subscription_member.remaining_amount') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.subscription_member.payment_status') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.subscription_member.remaining_days') }}
                    </th>
                    <th>
                        {{ i18n.t('tables.action') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(subscription) in subscriptionMembers" v-bind:key="subscription.id">
                    <td v-if="!isMember">

                        <member-route v-if="hasPermission('fiche_member')"
                            :memberUUID="isMember ? member?.uuid : subscription?.member_info?.uuid"
                            :matricule="isMember ? member?.matricule : subscription?.member_info?.matricule" />
                        <span v-else>
                            {{ isMember ? member?.matricule : subscription?.member_info?.matricule }}
                        </span>

                    </td>
                    <td v-if="!isMember">
                        {{ isMember ? member?.matricule : subscription?.member_info?.name }}
                    </td>
                    <td>
                        {{ subscription?.contractNumber ?? '' }}
                    </td>
                    <td>
                        <!-- Subscription & Pack Name -->
                        <div class="fw-bold text-dark">
                            {{ subscription?.subscription?.name }}
                        </div>
                        <div class="text-muted fw-bold small">
                            {{ subscription?.pack?.name }}
                        </div>

                        <!-- Subscription Holder (If available) -->
                        <div v-if="subscription?.parent_name" class="text-secondary small mt-1">
                            <span class="fw-semibold">{{ i18n.t('status.subscription_holder') }}:</span>
                            <span>{{ subscription?.parent_name }}</span>
                        </div>

                        <!-- Status Badges -->
                        <div class="mt-2">
                            <!-- Condition 1: Premier Abonnement (Blue) -->
                            <span v-if="!subscription.is_renewal" class="badge bg-success  text-black px-2 py-1"
                                title="C'est le tout premier abonnement de ce membre">
                                ✨ Premier Abonnement
                            </span>

                            <!-- Condition 2: Même pack (Green) -->
                            <span v-else-if="subscription.is_same_prev_pack"
                                class="badge bg-primary text-white px-2 py-1"
                                title="Ce membre a renouvelé exactement le même pack que son abonnement précédent">
                                🔄 Même pack (Précédent)
                            </span>

                            <!-- Condition 3: Changement de pack (Orange/Dark) -->
                            <span v-else class="badge bg-warning text-dark px-2 py-1"
                                title="Ce membre a changé de pack par rapport à son abonnement précédent">
                                🔀 Changement (vs Précédent)
                            </span>
                        </div>
                    </td>
                    <td>
                        {{ formatDate(subscription.created_at) }}
                    </td>
                    <td>
                        {{ formatDate(subscription.start_date) }}
                    </td>
                    <td>
                        {{ formatDate(subscription.end_date) }}
                    </td>
                    <td>
                        {{ subscription?.total_amount ?? 0.00 }} {{
                            i18n.t('symbole.currency.mad') }}
                    </td>
                    <td>
                        {{ subscription?.total_amount_paid ?? 0.00 }} {{
                            i18n.t('symbole.currency.mad') }}
                    </td>
                    <td>
                        {{ subscription?.remaining_amount ?? 0.00 }} {{
                            i18n.t('symbole.currency.mad')
                        }}
                    </td>
                    <td>
                        <element-is-paid :remaining_amount="subscription?.remaining_amount" />
                    </td>
                    <td>
                        <!-- {{ subscription?.status?.remaining_days }} {{ i18n.t('symbole.day') }} -->

                        <element-status-subscription :subscription="subscription" />
                    </td>



                    <td>
                        <btn-default v-if="hasPermission('impayes')" :btnClass="`btn btn-show m-1`"
                            @default="redirectTo({ name: 'impayes', params: { subscriptionID: subscription?.id, clubUUID: clubUUID, memberUUID: isMember ? member?.uuid : subscription?.member_info?.uuid } })"
                            icon="eye" :tooltip="i18n.t('button.details')" />

                        <btn-delete v-if="hasPermission('delete_member_subscription')"
                            @delete="deleteSubscriptionMember(subscription?.id)" />



                        <member-contract v-if="hasPermission('download_contract') && contract" :show-text="false"
                            classes="btn btn-file m-1" :member="isMember ? member : subscription?.member_info"
                            :subscription="subscription" :key="subscription.id" />



                        <!-- <btn-default v-if="hasPermission('download_contract') && contract"
                            :btnClass="`btn btn-file m-1`"
                            @default="exportContract(isMember ? member : subscription?.member_info, subscription)"
                            icon="file-pdf" :tooltip="i18n.t('button.download', { title: 'contrat' })" /> -->
                        <btn-default v-if="hasPermission('download_invoice') && invoice" :btnClass="`btn btn-file m-1`"
                            @default="exportInvoice(isMember ? member : subscription?.member_info, subscription)"
                            icon="file-invoice" :tooltip="i18n.t('button.download', { title: 'facture' })" />


                        <btn-default v-if="hasPermission('extend_subscriptions')" :btnClass="`btn btn-success m-1`"
                            @default="redirectTo({
                                name: 'update-datefin',
                                params: {
                                    clubUUID: clubUUID,
                                    memberUUID: subscription?.member_info?.uuid,
                                    subscriptionID: subscription?.id,
                                },
                            })" icon="calendar-plus" :tooltip="i18n.t('button.update_date_fin')" />

                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else>
            <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType, ref } from "vue";

import i18n from "@/i18n/index";
/*Components*/

import type { SubscriptionMember } from "@/interfaces/subscriptionMember";
import type { Member } from "@/interfaces/member";

import { useSubscription } from "@/composables/member/useSubscription";
import { usePermission } from "@/composables/auth/usePermission";
import { useGlobal } from "@/composables/global/useGlobal";
import { useContrat } from "@/composables/pdf/memberContract/useContrat";
import { useInvoice } from "@/composables/pdf/memberContract/useInvoice";

import { userPermissions, clubUUID, participations, currentClub, signatureImage, logoImage } from "@/shared/state";
export default defineComponent({
    components: {
    },
    name: "subscriptions-list",
    props: {
        subscriptionMembers: {
            type: Array as PropType<SubscriptionMember[] | null>,
            default: null,
        },
        member_UUID: {
            type: String,
            default: ''
        },
        contract: {
            type: Boolean,
            default: false
        },
        invoice: {
            type: Boolean,
            default: false
        },
        isMember: {
            type: Boolean,
            default: false
        },
        member: {
            type: Object as PropType<Member | null>,
            default: null,
        }
    },
    setup() {
        const {
            formatDate,
            redirectTo,
            printOrSaveToPdf, getBase64Image, convertToBase64
        } = useGlobal();

        const { hasPermission } = usePermission();
        const { contratPDF } = useContrat();
        const { invoicePDF } = useInvoice();
        const { deleteSubscriptionMember, isRequestSubscription } = useSubscription();
        const userPermissionsList = computed(() => userPermissions.data);
        const participationsList = computed(() => participations.data);


        /**Contract member**/
       

        let refLogo = ref<HTMLImageElement | null>(null);
        const exportContract = async (memberInfo: any, subscription: SubscriptionMember) => {
            const logoImageData = getBase64Image(logoImage.value);
            const signatureImageData = getBase64Image(signatureImage.value);
            const swalOption = {
                title: i18n.t('message.confirmation.export.invoice.title'),
                denyButtonText: i18n.t('message.confirmation.export.invoice.button.print'),
                cancelButtonText: i18n.t('button.cancel'),
                confirmButtonText: i18n.t('message.confirmation.export.invoice.button.pdf'),
            }
            const exportedType = await printOrSaveToPdf(swalOption)
            if (exportedType !== 'cancel') {

                contratPDF(memberInfo, subscription,
                    {
                        logoImageData,
                        logoNaturalWidth: logoImage?.value?.naturalWidth,
                        logoNaturalHeight: logoImage?.value?.naturalHeight,
                    },
                    {
                        signatureImageData: signatureImageData ?? null,
                        signatureNaturalWidth: signatureImage?.value?.naturalWidth ?? null,
                        signatureNaturalHeight: signatureImage?.value?.naturalHeight ?? null,
                    },

                    exportedType)
            }
        }
        const exportInvoice = async (memberInfo: any, subscription: SubscriptionMember) => {
            const logoImageData = getBase64Image(logoImage.value);
            const signatureImageData = getBase64Image(signatureImage.value);
            const swalOption = {
                title: i18n.t('message.confirmation.export.invoice.title'),
                denyButtonText: i18n.t('message.confirmation.export.invoice.button.print'),
                cancelButtonText: i18n.t('button.cancel'),
                confirmButtonText: i18n.t('message.confirmation.export.invoice.button.pdf'),
            }
            const exportedType = await printOrSaveToPdf(swalOption)
            if (exportedType !== 'cancel') {
                invoicePDF(memberInfo, subscription,

                    {
                        logoImageData,
                        logoNaturalWidth: logoImage?.value?.naturalWidth,
                        logoNaturalHeight: logoImage?.value?.naturalHeight,
                    },
                    {
                        signatureImageData: signatureImageData ?? null,
                        signatureNaturalWidth: signatureImage?.value?.naturalWidth ?? null,
                        signatureNaturalHeight: signatureImage?.value?.naturalHeight ?? null,
                    },

                    exportedType)
            }
        }


        return {
            refLogo,
            exportContract,
            exportInvoice,
            formatDate,
            redirectTo,
            clubUUID,
            i18n,
            hasPermission,
            deleteSubscriptionMember,
            participationsList,
            userPermissionsList,
            isRequestSubscription
        };
    },
});
</script>
